module.exports = __webpack_public_path__ + "media/images/front/pc/atopy-control-check/img02-6a637d1f4d567f939fc10dc8c7080cb9.png";